<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Apuração de Faturamento</h5>
      </div>
    </div>
    <div class="row">
      <b-container fluid>
        <div class="card">
          <div class="card-body">
            <h4 class="mb-4">
              <strong>Filtros de Busca</strong>
            </h4>
            <a-form layout="vertical">
              <div class="row">
                <div v-if="sysAdminUser" class="col-md-3">
                  <a-form-item label="Canal de Venda">
                    <a-select
                      v-model="filtrosLocal.idSalechannel"
                      @change="handleSaleChannelChange"
                    >
                      <a-select-option value=""> Selecione </a-select-option>
                      <a-select-option
                        :value="item.id"
                        v-for="(item, index) in saleChannels"
                        :key="`saleChannels-${index}`"
                      >
                        {{ item.description }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div class="col-md-3" v-if="showCostCenter">
                  <a-form-item label="Centro de Custo">
                    <a-select
                      default-value="0"
                      v-model="filtrosLocal.idCostCenter"
                    >
                      <a-select-option value="0"> Selecione </a-select-option>
                      <a-select-option
                        :value="item.id"
                        v-for="(item, index) in costCenters"
                        :key="`costCenters-${index}`"
                      >
                        {{ item.description }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div class="col-md-3">
                  <a-form-item label="Estabelecimento">
                    <v-select
                      label="name"
                      :filterable="false"
                      :options="merchants"
                      :reduce="(merchant) => merchant.id"
                      v-model="filtrosLocal.idMerchant"
                      @search="onSearch"
                    >
                      <template slot="no-options">Pesquisar Estabelecimento</template>
                      <template slot="option" slot-scope="option">{{
                        option.name
                      }}</template>
                      <template slot="selected-option" slot-scope="option">{{
                        option.name
                      }}</template>
                    </v-select>
                  </a-form-item>
                </div>

                <div class="col-md-3">
                  <a-form-item label="Período">
                    <a-select v-model="filtrosLocal.months">
                      <a-select-option value="1">Mensal</a-select-option>
                      <a-select-option value="2">Bimestral</a-select-option>
                      <a-select-option value="3">Trimestral</a-select-option>
                      <a-select-option value="6">Semestral</a-select-option>
                      <a-select-option value="12">Anual</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <b-button class="col-12" @click="limparFiltros"
                    >Limpar</b-button
                  >
                </div>
                <div class="col-md-2">
                  <b-button
                    class="col-12"
                    @click="filtrar"
                    variant="outline-primary"
                    >Filtrar</b-button
                  >
                </div>
              </div>
            </a-form>
          </div>
        </div>
        <template v-if="loading">
          <div class="d-flex justify-content-center bd-highlight mb-3">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="card">
            <div class="card-body">
              <b-table
                show-empty
                stacked="md"
                striped
                :borderless="true"
                :items="displayItens"
                :fields="fields"
                :per-page="perPage"
                :filter="filter"
              >
                <template v-slot:cell(startPeriod)="text">
                  {{ moment(text.value).format("DD/MM/YYYY") }}</template
                >
                <template v-slot:cell(endPeriod)="text">
                  {{ moment(text.value).format("DD/MM/YYYY") }}</template
                >
                <template v-slot:cell(billingForecast)="text">
                  {{ text.value | money }}</template
                >
                <template v-slot:cell(expectedForecast)="text">
                  {{ text.value | money }}</template
                >
                <template v-slot:cell(currentForecast)="text">
                  {{ text.value | money }}</template
                >

                <template v-slot:cell(passed)="row">
                  <span class="fe fe-check-circle success" v-if="row.value" />
                  <span class="fa fa-times-circle error" v-else />
                </template>

                <template v-slot:cell(idMerchant)="row">
                  <b-button size="sm" :href="`/merchant/${row.value}/edit`"
                    ><i class="fe fe-edit"></i
                  ></b-button>
                </template>
              </b-table>

              <b-row>
                <b-col md="6" class="my-1">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    @input="onChangePage"
                    class="my-0"
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </template>
      </b-container>
    </div>
  </div>
</template>
<style lang="scss">
@import "../../../../assets/styles/mixins";
.success {
  color: $success;
}
.error {
  color: $danger;
}
</style>
<script>
import { get as _get, debounce as _debounce } from "lodash";
import moment from "moment";
import { TransactionResource } from "@/resources/Transaction.resource.js";

export default {
  name: "ListaEquipamentos",
  data() {
    return {
      loading: false,
      filtrosLocal: {
        index: 1,
        size: 25,
        months: "1",
        idCostCenter: null,
        idSaleChannel: null,
        idMerchant: null,
      },
      itens: [],
      costCenters: [],
      saleChannels: [],
      displayItens: [],
      fields: [
        // {
        //   key: "idMerchant",
        //   dataIndex: "idMerchant",
        //   label: "#",
        // },
        {
          key: "saleChannel",
          dataIndex: "saleChannel",
          label: "Parceiro",
        },
        // {
        //   key: "socialReason",
        //   dataIndex: "socialReason",
        //   label: "Razão Social",
        // },
        { key: "name", dataIndex: "name", label: "Estabelecimento" },
        {
          key: "billingForecast",
          dataIndex: "billingForecast",
          label: "Fat Informado",
          scopedSlots: { customRender: "billingForecast" },
        },
        {
          key: "expectedForecast",
          dataIndex: "expectedForecast",
          label: "Fat Previsto",
          scopedSlots: { customRender: "expectedForecast" },
        },
        {
          key: "currentForecast",
          dataIndex: "currentForecast",
          label: "Fat Apurado",
          scopedSlots: { customRender: "currentForecast" },
        },
        {
          key: "passed",
          dataIndex: "passed",
          label: "Status",
          scopedSlots: { customRender: "passed" },
        },
        {
          key: "startPeriod",
          dataIndex: "startPeriod",
          label: "Inicio",
          scopedSlots: { customRender: "startPeriod" },
        },
        {
          key: "endPeriod",
          dataIndex: "endPeriod",
          label: "Fim",
          scopedSlots: { customRender: "endPeriod" },
        },
        {
          key: "idMerchant",
          dataIndex: "idMerchant",
          label: "Opções",
          scopedSlots: { customRender: "options" },
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      filter: null,
      merchants: [],
      dipositivoEditar: null,
    };
  },
  methods: {
    moment,
    getCostCenters() {
      this.$api
        .get("v1/CostCenter/keyvalue")
        .then((result) => {
          this.costCenters = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },
    getSaleChannels() {
      this.$api
        .get("v1/saleChannel/keyValue")
        .then((result) => {
          this.saleChannels = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },
    handleSaleChannelChange() {
      this.filtrosLocal.idCostCenter = null;
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/merchant/keyvalue", {
          params: {
            name: search,
          },
        })
        .then((result) => {
          loading(false);
          vm.merchants = result.data.payload.map((item) => ({
            id: item.id,
            name: item.description,
          }));
        });
    }, 350),
    getLista() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        this.loading = true;

        TransactionResource.getBillingForecast(this.filtrosLocal)
          .then((result) => {
            try {
              this.itens[this.filtrosLocal.index] = result.data.payload.items;
              this.displayItens = this.itens[this.filtrosLocal.index].flat();
              this.totalRows = result.data.payload.pageSettings.total;
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.loading = false;
          });
      } else {
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },
    onChangePage(a) {
      this.filtrosLocal.index = a;
      this.getLista();
    },
    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 25,
        months: 1,
      };
      this.filtrar();
    },
    filtrar() {
      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getLista();
    },
  },
  computed: {
    showCostCenter() {
      try {
        let result = true;
        result &= !(parseInt(this.$store.getters.user.costcenter) > 0);
        return result;
      } catch (e) {
        return false;
      }
    },
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.filtrar();
  },
  created() {
    if (this.showCostCenter) this.getCostCenters();
    if (this.sysAdminUser) this.getSaleChannels();
  },
};
</script>